import React, { PureComponent, Fragment, memo } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import DatePicker from '../../../components/UI/DatePicker/DatePicker';
import TarjetaOrden from "../../../components/UI/Orden/tarjetaOrden.jsx";
import Articulos from './detalleArticulos.jsx';
import ArticulosSuc from './detalleArticulosSuc.jsx';
import { groupBy } from '../../../components/Util/Util';
import GoogleMapControl from '../../../components/UI/mapa/mapaGoogle';

class monitorSucursalInt extends PureComponent {
    state = {
        fecha_activa_inicio: new Date(),
        fecha_activa_fin: new Date(),
        maxDate: new Date(),
        listaOrdenes: [],
        listaSubOrdenes: [],
        estadoOrdenes: '',
        showInstruccionesEntrega: false
    }

    componentDidMount() {
        this.setDates();
    }

    componentDidUpdate(prevProps) {
        if (this.props.diasCalendarizados && this.props.diasCalendarizados !== prevProps.diasCalendarizados) {
            this.setDates();
        }
    }

    setDates = () => {
        let maxDate = new Date();
        maxDate.setMonth(maxDate.getMonth() + 1);
        maxDate.setHours(23, 59, 59, 0);

        let fecha_activa_fin = new Date();
        if (this.props.diasCalendarizados && this.props.diasCalendarizados > 0) {
            fecha_activa_fin.setDate(fecha_activa_fin.getDate() + this.props.diasCalendarizados);
        }

        this.setState({ maxDate, fecha_activa_fin });
    };

    onChangeDate = (name, dates) => {
        const [start, end] = dates;

        this.setState({ fecha_activa_inicio: start, fecha_activa_fin: end });
        if (end) {
            this.props.onChangeFechaActiva(dates);
        }
    }

    onClickTodayDate = () => {
        const newDate = new Date();
        this.setState({ fecha_activa_inicio: newDate, fecha_activa_fin: new Date() });
        this.props.onChangeFechaActiva([newDate, new Date()]);
    }

    checkDates = (pFechaInicio, pFechaFin) => {
        if (!pFechaInicio && pFechaFin) {
            pFechaInicio = pFechaFin;
        }
        else {
            if (pFechaInicio && !pFechaFin) {
                pFechaFin = pFechaInicio;
            }
            else {
                pFechaInicio = new Date();
                pFechaFin = new Date();
            }
        }

        let newDateIni = new Date(pFechaInicio);
        newDateIni.setHours(0, 0, 0, 0);

        let newDateFin = new Date(pFechaFin);
        newDateFin.setHours(23, 59, 59, 0);

        this.setState({ fecha_activa_fin: newDateFin, fecha_activa_inicio: newDateIni });
        this.props.onChangeFechaActiva([newDateIni, newDateFin]);
    }

    onClickPreviousDate = () => {
        let currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);

        let fecha_inicio = this.state.fecha_activa_inicio;
        let fecha_final = this.state.fecha_activa_fin;
        if (fecha_inicio && fecha_final) {

            let newDateIni = new Date(fecha_inicio);
            newDateIni.setHours(0, 0, 0, 0);

            if (newDateIni > currentDate) {
                newDateIni.setDate(newDateIni.getDate() - 1);
                this.setState({ fecha_activa_inicio: newDateIni });
                this.props.onChangeFechaActiva([newDateIni, fecha_final]);
            }
        }
        else {
            this.checkDates(fecha_inicio, fecha_final);
        }
    }

    onClickNextDate = () => {
        let currentDate = new Date();
        currentDate.setHours(23, 59, 59, 0);

        let fecha_inicio = this.state.fecha_activa_inicio;
        let fecha_final = this.state.fecha_activa_fin;
        if (fecha_inicio && fecha_final) {

            let newDateFin = new Date(fecha_final);
            newDateFin.setHours(23, 59, 59, 0);

            if (newDateFin < this.state.maxDate) {
                newDateFin.setDate(newDateFin.getDate() + 1);
                this.setState({ fecha_activa_fin: newDateFin });
                this.props.onChangeFechaActiva([fecha_inicio, newDateFin]);
            }
        }
        else {
            this.checkDates(fecha_inicio, fecha_final);
        }
    }

    render() {
        const { showInstruccionesEntrega } = this.state;
        const { listaOrdenes, ordenUbicacion, articulos, articulosAp, sucApoyo, mapa, Despachar, DespacharLabel, Imprimir } = this.props;
        const fecha = new Date();
        const ordenes = groupBy(listaOrdenes, orden => moment(orden.Fec_Activar).isSameOrBefore(moment(fecha), 'minutes') ? 'current' : 'future');
        let numTraslado = '';
        if (articulos.length > 0) {
            numTraslado = articulos[0].Mov_Id;
        }
        let traslado = null;
        if (ordenUbicacion.sucFact > 0) {
            traslado = (this.props.sucursal.Id != ordenUbicacion.sucFact ? <div className="row">
                <div className="col mt-2">
                    <p className="traslado">Número de traslado</p>
                </div>
                <div className="col mt-2">
                    <p className="traslado"><span className="dot"></span>{numTraslado}</p>
                </div>
            </div> : null);
        }

        const Tarjetas = ({ lista }) => {
            return lista && lista.length > 0 ? lista.map(item => {
                return <TarjetaOrden
                    col={6}
                    claseEstado={item.claseTarj}
                    claseTipo={(item.Tipo_Entrega)}
                    claseApoyo={(item.Apoyo === 'NO' ? '' : (item.Apoyo === 'RA' ? "flaticon-inbox" : "flaticon-outbox"))}
                    item={item}
                    onClick={this.props.onClickOrdenes}
                    seleccionado={item.Seleccionado}
                />
            }) : null;

        }

        let lastFutureDate = null;
        let hour = -1;
        const futureRows = ordenes.future && ordenes.future.length > 0 ? ordenes.future.map(orden => {
            const activeHour = moment(orden.Fec_Activar).hours();
            const activeDate = moment.utc(orden.Fec_Activar).startOf('day');

            let separador = null;
            if (hour === -1 || hour !== activeHour) {
                separador = <div className="row">
                    <div className="col">
                        {!lastFutureDate || activeDate > lastFutureDate ?
                            <div className="row">
                                <div className="col-auto grupo-ordenes-dia"><span style={{ textTransform: 'capitalize' }}>{`${moment(orden.Fec_Activar).locale("es").format("dddd")} ${moment(orden.Fec_Activar).format('DD/MM/yyyy')}`}</span></div>
                                <div className="col grupo-ordenes-dia-linea"></div>
                            </div> : null}
                        <div className="grupo-ordenes-2">{moment(orden.Fec_Activar).format('h A')}</div>
                    </div>
                </div>;
                hour = activeHour;
            }
            lastFutureDate = activeDate;

            return <Fragment>
                {
                    separador
                }
                <TarjetaOrden
                    col={6}
                    claseEstado={orden.claseTarj}
                    claseTipo={(orden.Tipo_Entrega)}
                    claseApoyo={(orden.Apoyo === 'NO' ? '' : (orden.Apoyo === 'RA' ? "flaticon-inbox" : "flaticon-outbox"))}
                    item={orden}
                    onClick={this.props.onClickOrdenes}
                    seleccionado={orden.Seleccionado}
                />

            </Fragment>

        }) : null;

        let lat = 0;
        let lng = 0;
        let title = '';
        let icon = '';
        if (mapa && mapa.location) {
            lat = mapa.location.latitud;
            lng = mapa.location.longitud;
            title = mapa.option.title;
            icon = mapa.option.icon;
        }

        return (
            <Fragment>
                <section className="monitor-suc">
                    <div className="row no-gutters">
                        <div className="col-6">
                            <div className="lista-ordenes">
                                <div className="row">
                                    <div className="col-6">
                                        <h1>Órdenes</h1>
                                    </div>
                                    <div className="col-6">
                                        <input className="form-control" type="search" placeholder="Buscar" value={this.props.filtro} onChange={this.props.onChangeBuscar} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="grupo-ordenes">Órdenes Activas</div>
                                    </div>
                                </div>
                                <div className="row">
                                    <Tarjetas lista={ordenes.current} />
                                </div>
                                <div className="row mt-5">
                                    <div className="col-auto">
                                        <button id="btnToday" className="btn btn-secondary" onClick={this.onClickTodayDate}>Hoy</button>
                                    </div>
                                    <div className="col-auto">
                                        <button id="btnPreviousDay" className="btn btn-primary" onClick={this.onClickPreviousDate}><FontAwesomeIcon icon={faChevronLeft} /></button>
                                    </div>
                                    <div className="col-auto">
                                        <DatePicker name="fecha_activa" value={this.state.fecha_activa_inicio} onChange={this.onChangeDate} props={{
                                            selectsRange: true,
                                            startDate: this.state.fecha_activa_inicio,
                                            endDate: this.state.fecha_activa_fin,
                                            minDate: new Date(),
                                            maxDate: this.state.maxDate
                                        }} />
                                    </div>
                                    <div className="col-auto">
                                        <button id="btnNextDay" className="btn btn-primary" onClick={this.onClickNextDate}><FontAwesomeIcon icon={faChevronRight} /></button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        {futureRows}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-3">
                            <div className="orden-ubicacion">
                                <div className="row">
                                    <div className="col">
                                        <button type="button" className={` btn  ${Imprimir ? 'btn-primary' : 'btn-secondary'} btn-lg btn-block`} onClick={this.props.onClickImprimirHandler}>
                                            <i className="fas fa-print"></i> Imprimir
                                        </button>
                                    </div>
                                    <div className="col">
                                        <button type="button" className={` btn  ${Despachar ? 'btn-primary' : 'btn-secondary'} btn-lg btn-block`} data-toggle="modal"
                                            data-target="#despacharModal" onClick={this.props.onClickDespachoHandler}><i className="fas fa-box"></i>
                                            {DespacharLabel}
                                        </button>
                                    </div>
                                </div>
                                {
                                    ordenUbicacion.Instrucciones_Entrega ?
                                        <div className="row mt-2">
                                            <div className="col">
                                                <button type="button" className='btn btn-primary btn-lg btn-block' onClick={() => this.setState({ showInstruccionesEntrega: true })}>
                                                    Instrucciones de Entrega
                                                </button>
                                            </div>
                                        </div>
                                        : null
                                }
                                <br></br>
                                <div className="row">
                                    <div className="col">
                                        <h6>{ordenUbicacion.Fecha} </h6>
                                        <h5>{`# ${ordenUbicacion.Orden}`}</h5>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <span className="badge badge-warning">{ordenUbicacion.Estado}</span>
                                        <span className="badge badge-secondary">Disponible: <span className="time">{`${ordenUbicacion.Disponible_Positivo ? " +" : "-"} ${ordenUbicacion.Disponible}`}</span></span>
                                    </div>
                                </div>
                                <div className="row">
                                    <br></br>
                                    <br></br>
                                    <div className="col">
                                        <label>Teléfono</label>
                                        <p>{ordenUbicacion.Telefono}</p>
                                    </div>
                                    <div className="col">
                                        <label>Nombre</label>
                                        <p>{ordenUbicacion.Nombre}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="map-three">
                                            <GoogleMapControl
                                                center={{ lat, lng }}
                                                zoom={15}
                                                position={{ lat, lng }}
                                                title={title}
                                                label={title}
                                                icon={icon}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <p>{`${ordenUbicacion.Ubicacion} ${ordenUbicacion.DireccionAdic}`}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <label>Localidad</label>
                                        <p>{ordenUbicacion.Localidad}</p>
                                    </div>
                                    <div className="col">
                                        <label>Observaciones</label>
                                        <p>{ordenUbicacion.Observaciones}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <label>Peso</label>
                                        <p>{ordenUbicacion.Peso}</p>
                                    </div>
                                    <div className="col">
                                        <label>Cubicaje</label>
                                        <p className="cub">{ordenUbicacion.Cubicaje}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <label>Transporte</label>
                                        <p>{ordenUbicacion.Transporte}</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="articulos">
                                <h5>Artículos</h5>
                                {traslado}
                                <div className="row">

                                    <div className="col">
                                        <div className="lista">
                                            <Articulos articulos={articulos} />
                                            {
                                                sucApoyo.map(suc => {
                                                    return (
                                                        <ArticulosSuc
                                                            articulos={articulosAp}
                                                            sucursalArt={suc}
                                                            sucFact={ordenUbicacion.sucFact}
                                                        />
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal show={showInstruccionesEntrega} onHide={() => this.setState({ showInstruccionesEntrega: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <h5 className="modal-title">Instrucciones de Entrega</h5>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col">
                                <p className="break-word">{ordenUbicacion.Instrucciones_Entrega}</p>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showInstruccionesEntrega: false })}>
                            Cerrar
                        </button>
                    </Modal.Footer>
                </Modal>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        usuarioLogueado: state.usuario.usuarioLogueado,
        empresa: state.parametros.empresa,
        sucursal: state.parametros.sucursal,
        callCenter: state.parametros.callCenter
    };
};

export default connect(mapStateToProps)(withRouter(memo(monitorSucursalInt)));
